export const copy = {
  ko: {
    common: {
      brand: 'MIMIC',
      brandKo: '미믹',
      videoUnsupported: '브라우저가 영상을 지원하지 않습니다.',
    },
    topBar: {
      langKo: '한국어',
      langEn: 'English',
      ariaLangSwitch: '언어 전환',
      cta: 'App Store',
      ctaAriaLabel: 'App Store에서 MIMIC 다운로드',
    },
    hero: {
      titleTop: '좋아하는 콘텐츠로, 듣고 따라하며 배우세요',
      titleMiddle: '미믹킹으로 시작하는 언어 습득',
      iosLabel: 'App Store에서',
      iosStore: '다운로드',
      iosAriaLabel: 'App Store에서 MIMIC 다운로드',
      androidLabel: 'Google Play에서',
      androidStore: '다운로드',
      androidAriaLabel: 'Google Play에서 MIMIC 다운로드',
      appIconAlt: 'MIMIC 앱 아이콘',
    },
    languageSecret: {
      title: '언어 습득의 원리',
      quote1Lines: [
        '언어학자 스티븐 크라센은 말합니다.',
        '좋아하는 콘텐츠에 충분히 노출되는 것이',
        '언어 습득의 출발점이라고.',
      ],
      quote2Lines: [
        '이 원리를 실현한 비법이 있습니다.',
        '수많은 사람들의 공감을 얻은',
        '익명 영어 고수의 방법,',
        '좋아하는 영화·드라마로 미믹킹하기',
      ],
      sourceLink: '원본 링크',
      sliderAlt: (n) => `참고 이미지 ${n}`,
      muteOn: '소리 켜기',
      muteOff: '소리 끄기',
      goToImage: (n) => `이미지 ${n}로 이동`,
    },
    solution: {
      title: '좋아하는 콘텐츠 와 미믹킹',
      problem: '방법은 알겠는데, 시작이 어렵다면',
      headlineAfterBrand: '이 시작을 간단하게 만듭니다.',
      appIconAlt: 'MIMIC 앱 아이콘',
    },
    featuresDetail: {
      label: '특징',
      title: '좋아하는 콘텐츠로 학습을 시작하세요',
      subtitlePrefix: '어떤 콘텐츠든,',
      subtitleSuffix: '이 학습 자료로 정리합니다.',
      modes: {
        upload: {
          title: 'AI 분석',
          description: '휴대폰에 저장된 영상을 학습 자료로 바꿉니다.',
        },
        record: {
          title: '실시간 녹음',
          description: '미팅·대화 등 실시간 음성을 정리해 학습 자료로 저장합니다.',
        },
      },
      replay: '다시보기',
    },
    learningFeatures: {
      title: '학습을 끝까지 이어주는 기능',
      panel: {
        title: '재생 패널',
        imageAlt: '재생 패널 인터페이스',
        items: [
          { title: '문장 미믹킹 모드', desc: '문장 무음 재생' },
          { title: '앞 문장\n재생', desc: '' },
          { title: '재생\n일시 정지', desc: '' },
          { title: '뒷 문장\n재생', desc: '' },
          { title: '구간 순환 재생,\n한 문장 반복 재생', desc: '' },
        ],
      },
      playlist: {
        title: '재생목록',
        imageAlt: '재생목록 기능 화면',
        desc: '집중 학습이 필요한 문장을 재생목록으로 만들어 학습해 보세요.',
      },
    },
    ipad: {
      title: 'iPad도 완벽하게',
      subtitle: '태블릿 UI까지 최적화해 더 큰 화면에서 편하게 학습하세요.',
      altPortrait: 'iPad 세로 화면 예시',
      altLandscape: 'iPad 가로 화면 예시',
    },
    everywhere: {
      titleLines: ['언제 어디서나', 'MIMIC'],
      subtitleLines: ['잠금 화면과 시스템 오디오로', '끊김 없이 이어지는 학습'],
      lockAlt1: '잠금 화면 예시 1',
      lockAlt2: '잠금 화면 예시 2',
    },
    videoSection: {
      titleLines: ['내가 좋아하는', '콘텐츠로', '직접 만들자'],
      subtitleLines: ['유튜브, 넷플릭스, 팟캐스트…', '좋아하는 모든 콘텐츠가', '나만의 학습 자료가 됩니다'],
      features: ['영상 자동 분석', '실시간 피드백', '발음 개선 추적'],
    },
    mimicking: {
      subtitleLines: ['외국어 고수들 사이에서', '비밀처럼 전해오던 방법'],
      mimickingText: '미믹킹',
      titleSuffixLines: ['을', '여기서.'],
    },
    concept: {
      items: [
        { q: '문법?', a: '아니' },
        { q: '쉐도잉?', a: '아니' },
        { q: 'MIMIC!', a: '바로 그거야', isBrand: true },
      ],
    },
    featuresSection: {
      titleLines: ['뭘 좋아할지 몰라서', '다 준비했어'],
      cta: '8개 언어로 자유롭게 학습하세요',
      languages: [
        { name: '영어', emoji: '🇬🇧' },
        { name: '일본어', emoji: '🇯🇵' },
        { name: '중국어', emoji: '🇨🇳' },
        { name: '프랑스어', emoji: '🇫🇷' },
        { name: '독일어', emoji: '🇩🇪' },
        { name: '스페인어', emoji: '🇪🇸' },
        { name: '이탈리아어', emoji: '🇮🇹' },
        { name: '베트남어', emoji: '🇻🇳' },
      ],
    },
    footer: {
      iconAlt: 'MIMIC',
      tagline: '으로 시작하는 더 자연스러운 언어 습득',
      links: {
        terms: '이용약관',
        privacy: '개인정보 처리방침',
      },
    },
  },
  en: {
    common: {
      brand: 'MIMIC',
      brandKo: '미믹',
      videoUnsupported: 'Your browser does not support the video tag.',
    },
    topBar: {
      langKo: 'Korean',
      langEn: 'English',
      ariaLangSwitch: 'Language switch',
      cta: 'Get the app',
      ctaAriaLabel: 'Download MIMIC on the App Store',
    },
    hero: {
      titleTop: 'Learn with what you love—listen and repeat',
      titleMiddle: 'Language acquisition through mimicking',
      iosLabel: 'Download on the',
      iosStore: 'App Store',
      iosAriaLabel: 'Download MIMIC on the App Store',
      androidLabel: 'Get it on',
      androidStore: 'Google Play',
      androidAriaLabel: 'Download MIMIC on Google Play',
      appIconAlt: 'MIMIC app icon',
    },
    languageSecret: {
      title: 'How language is acquired',
      quote1Lines: [
        'Linguist Stephen Krashen says:',
        'Rich exposure to content you enjoy',
        'is where acquisition begins.',
      ],
      quote2Lines: [
        "There's a proven method for this.",
        'An anonymous language expert shared it,',
        'earning thousands of upvotes:',
        'Mimic your favorite movies and shows.',
        'MIMIC makes it effortless to begin.',
      ],
      sourceLink: 'Source',
      sliderAlt: (n) => `Reference image ${n}`,
      muteOn: 'Unmute',
      muteOff: 'Mute',
      goToImage: (n) => `Go to image ${n}`,
    },
    solution: {
      title: 'Content You Love & Mimicking',
      problem: 'Know the method, but not how to start?',
      headlineAfterBrand: ' makes the first step simple.',
      appIconAlt: 'MIMIC app icon',
    },
    featuresDetail: {
      label: 'Features',
      title: 'Turn what you love into a lesson',
      subtitlePrefix: 'With a single video,',
      subtitleSuffix: ' organizes it into practice-ready materials.',
      modes: {
        upload: {
          title: 'AI analysis',
          description: 'Turn saved videos on your phone into study materials.',
        },
        record: {
          title: 'Live recording',
          description: 'Capture meetings and conversations and save them for practice.',
        },
      },
      replay: 'Replay',
    },
    learningFeatures: {
      title: 'Features that keep you moving',
      panel: {
        title: 'Playback panel',
        imageAlt: 'Playback panel interface',
        items: [
          { title: 'Mimic mode\n(no audio)', desc: 'Play without audio' },
          { title: 'Previous\nsentence', desc: '' },
          { title: 'Play\npause', desc: '' },
          { title: 'Next\nsentence', desc: '' },
          { title: 'Loop segment\nRepeat sentence', desc: '' },
        ],
      },
      playlist: {
        title: 'Playlist',
        imageAlt: 'Playlist feature screen',
        desc: 'Save key sentences to a playlist and practice as much as you want.',
      },
    },
    ipad: {
      title: 'Built for iPad',
      subtitle: 'A tablet-optimized UI for a more comfortable learning experience.',
      altPortrait: 'iPad portrait screenshot',
      altLandscape: 'iPad landscape screenshot',
    },
    everywhere: {
      titleLines: ['Anytime, anywhere', 'MIMIC'],
      subtitleLines: ['Lock Screen and system audio', 'for uninterrupted practice'],
      lockAlt1: 'Lock Screen example 1',
      lockAlt2: 'Lock Screen example 2',
    },
    videoSection: {
      titleLines: ['Build lessons', 'from what', 'you love'],
      subtitleLines: ['YouTube, Netflix, podcasts…', 'Anything you enjoy', 'can become your study material'],
      features: ['Auto content analysis', 'Real-time feedback', 'Pronunciation tracking'],
    },
    mimicking: {
      subtitleLines: ['A method shared quietly', 'among advanced learners'],
      mimickingText: 'Mimicking',
      titleSuffixLines: ['right', 'here.'],
    },
    concept: {
      items: [
        { q: 'Grammar?', a: 'No.' },
        { q: 'Shadowing?', a: 'No.' },
        { q: 'MIMIC!', a: "That's it.", isBrand: true },
      ],
    },
    featuresSection: {
      titleLines: ['Whatever you like,', "we've got it ready"],
      cta: 'Practice freely in 8 languages',
      languages: [
        { name: 'English', emoji: '🇬🇧' },
        { name: 'Japanese', emoji: '🇯🇵' },
        { name: 'Chinese', emoji: '🇨🇳' },
        { name: 'French', emoji: '🇫🇷' },
        { name: 'German', emoji: '🇩🇪' },
        { name: 'Spanish', emoji: '🇪🇸' },
        { name: 'Italian', emoji: '🇮🇹' },
        { name: 'Vietnamese', emoji: '🇻🇳' },
      ],
    },
    footer: {
      iconAlt: 'MIMIC',
      tagline: 'Natural language acquisition, starting with MIMIC',
      links: {
        terms: 'Terms',
        privacy: 'Privacy',
      },
    },
  },
};

